import { fetchInfo, createOrder, getPriceAndDate } from "@/api/modules/products/controlFees";
import { invalidChars } from "@/utilities/chars";
import {reactive, watch, computed, nextTick} from "vue";

import { makeUtcDate } from "@/utilities/time";

function initialState() {
    return {
        feeNumber: null,
        feeNumberExists: true,
        feeDate: null
    };
}

function getNumberError(_state, getters, _rootState, rootGetters) {
    var value = state.feeNumber;
    if (!value) return ERROR_REQUIRED;

    if (!state.feeNumberExists) {
        return ERROR_FEE_NUMBER_INVALID;
    }

    return null;
}
function getNumberInvalidChars(_state, getters, _rootState, rootGetters) {
    return [];
}
const InfoModel = function (info) {
    this.identifier = info.productTypeIdentifier;
    this.products = new ProductModel(info.product, this.identifier);
};
const ProductModel = function (productData, identifier) {
    this.type = identifier;
};

export const ERROR_REQUIRED = "error_required";
export const ERROR_INVALID_CHARS = "error_invalid_chars";
export const ERROR_FEE_NUMBER_INVALID = "error_fee_number_invalid";
export const ERROR_FEE_NUMBER_LENGTH =
    "error_fee_number_length";

export const state = initialState();

export const mutations = {
    setNumber: (state, number) => {
        state.feeNumber = number;
        state.feeNumberExists = true
    },
    setFeeDate: (state, date) => {
        state.feeDate = date;
    },
    updateInfo: (state, payload) => {
        state.info = new InfoModel(payload.info);
    },
    updateFeeNumberExists: (state, payload) => {
        state.feeNumberExists = payload;
    }
};

watch(
    () => state.feeNumberExists,
    () => {
      getNumberError(state, getters, _rootState, rootGetters);
    }
   );

export const getters = {
    getNumber: state => state.feeNumber,
    getFeeDate: state => state.feeDate,
    getNumberInvalidChars,
    getNumberError
};

export const actions = {
    fetchInfo: context => {
        return fetchInfo(true)
            .then(response => {
                if (!response.ok) throw new Error(response.responseBody);
                return response.responseBody;
            })
            .then(response => {
                context.commit("updateInfo", { info: response });
            });
    },
    feeExsist: (context, { feeNumber }) => {
        return getPriceAndDate(feeNumber)
            .then(response => {
                return response.responseBody.exists;
            })
    },
    prepareOrder: (context, { product }) => {
        if (!product)
            throw new Error(
                "cannot prepare fixed price ticket order without a product"
            );

        const serverTime = makeUtcDate(
            context.rootGetters.getServerDateAsMoment
        );

        product = ref({
            date: serverTime
        });

        const feeNumber = context.rootGetters["products/controlfee/getNumber"];
        return getPriceAndDate(feeNumber)
            .then(response => {
                if (!response.ok) throw new Error(response.responseBody);
                return response.responseBody;
            })
            .then(response => {
                if (!response.exists) throw new Error(response);

                context.commit("order/setPriceOre", response.price, { root: true });
                context.commit("order/setDetails", { product }, { root: true });
                context.commit("products/controlfee/setFeeDate", response.feeDate, { root: true });
                context.commit("order/setDeliveryMethod", "controlfee", { root: true });
            });
    },
    createOrder: context => {
        const product = context.rootGetters["order/getDetails"].product;
        const feeNumber = context.rootGetters["products/controlfee/getNumber"];

        if (!product) throw new Error("cannot create order without a product");

        return createOrder(feeNumber, product.id).then(response => {
            if (!response.ok) throw new Error(JSON.stringify(response));
            return response.responseBody;
        })
            .then(response => {
                context.commit("order/setOrderId", response.orderId, { root: true });
                context.commit("order/setPriceOre", response.priceOre, { root: true });
                context.commit(
                    "order/setDetails",
                    {
                        product
                    },
                    { root: true }
                );
            });
    },
    //Might not be nessecary, but is an attempt to make sure getNumberError is called after the state has changed
    //Return value from getNumberError isn't used to do anything here
    async updateFeeNumberExistsAndValidate({ commit, state, getters }, payload) {
        console.log('Dispatching action with payload:', payload);
        commit('updateFeeNumberExists', payload);
        await nextTick();
        console.log('Calling function with state:', state);
        getNumberError(state, getters);
      }
};
